import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";
import Header from "./Header";
import Menu from "./Menu";
import "../assets/css/patient-symptom.css";
import { arrayExpression, thisTypeAnnotation } from "@babel/types";
import { CONFIG, URLS } from "../helpers/Common";
import { Modal , Container} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";

class PatientNarrative extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answersData: "",
      narrativeSummary: "",
      profileSummary: "",
      addNarrativeStep: 2,
      nextStep: 6,
      prevStep: 4,
      show: false,

    };
    this.addAnotherNarrative    = this.addAnotherNarrative.bind(this);
    this.handleUpdateAction     = this.handleUpdateAction.bind(this);
    
  }

  componentWillMount() {
    const patientAnswerData = this.props.getQuestionAnswersData.filter(
      val => val
    );
    let profileData = this.props.getProfileData;
    let narrativeSummary = "";
    
    // Get narrative summary of latest question answers data 

    if (!patientAnswerData) 
    { 
        this.history.push(URLS.master);
        // Object.values(patientAnswerData).forEach(function(row, key) {
        //     narrativeSummary += row.narrative_text+". ";
        // });
        // this.setState({
        //     narrativeSummary: narrativeSummary
        // });
    } 
    

    // Save question answers data into strage and Extract Summray or previous Question Answers

    let saveData = new Array();
    //patientAnswerData['complainLocationData']  = this.props.getComplainLocationData;
    //patientAnswerData['complainType']          = this.props.getComplainData.complain_types;
    saveData.push({
      'optionData':patientAnswerData,
      'complain_type':this.props.getComplainData.complain_types,
      'complainLocationData':this.props.getComplainLocationData,
      'surgeon_id':51
    });
    
    let data = localStorage.getItem("data");

    if(data) 
    {
      data = JSON.parse(data);
      
      // Get previous narrative summary from strage 

      // Object.values(data).forEach(function(row, key) {
      //     Object.values(row.optionData).forEach(function(row2, key) {
      //         narrativeSummary += row2.narrative_text+". ";

      //     });
          
      // });
      
      // Set narrative summary state
      // this.setState({
      //     narrativeSummary: narrativeSummary
      // });

      // Add and Update Question Answers in Storage

     // saveData.push({'optionData':patientAnswerData});
      // saveData.push({
      //   'optionData':patientAnswerData,
      //   'complain_type':this.props.getComplainData.complain_types,
      //   'priamry_complain':0,
      //   'complainLocationData':this.props.getComplainLocationData
      // });
      saveData[0]['primary_complain']=0;

      // Add Question Data in Storage array 
      data.push(saveData[0]);
      
    } 
    else 
    {
      // Add Question Data if user create 1st Complain

      // saveData.push({
      //   'optionData':patientAnswerData,
      //   'complain_type':this.props.getComplainData.complain_types,
      //   'priamry_complain':1,
      //   'complainLocationData':this.props.getComplainLocationData
      // });
      saveData[0]['primary_complain']=1;
      data = saveData;
    }

    //console.log(data);
    
    // Save data into storage
    localStorage.setItem("data", JSON.stringify(data));

    // Sort Summary by category order and save
    let summryData = new Array();
      Object.values(data).forEach(function(row, key) {
        Object.values(row.optionData).forEach(function(row2, key) {
          summryData.push({'narrative':row2.narrative_text,'order':row2.sort_order});
        });
      });
      summryData.sort((a, b) => a.order - b.order);
      Object.values(summryData).forEach(function(row, key) 
      {
        narrativeSummary += row.narrative+" ";
      });
      
      // get profile info here and add with narrative summary
    // Save Narrative Summary from props 
   
    let _profileSummary = profileData.title+" ";
    _profileSummary += profileData.first_name+" ";
    _profileSummary += profileData.last_name+" ";
    _profileSummary += (profileData.gender).toLowerCase()+" ";
    let year  = profileData.dob;
    let month  = profileData.dob;
    let day  = profileData.dob;
    year = year.substr(0,4);
    month = month.substr(5,2);
    day = day.substr(8,2);
    
    let date = month+"/"+day+"/"+year;
    
    date = this.getAge(date);
    _profileSummary += date+" ";
    this.setState({
      narrativeSummary:_profileSummary+narrativeSummary
    })
    this.props.setNarrativeSummary(_profileSummary+narrativeSummary)
    //this.history.push('/master');
  }
  addAnotherNarrative = e => {
    this.props.setQuestionAnswersData(new Array());
    this.props.setCheckedItems(new Map());
    this.props.handleNextPrevSteps(this.state.addNarrativeStep);
  };

  handleAction = e => {

    this.props.handleNextPrevSteps(this.state.nextStep);
  };
  handleUpdateAction = (e)=>
  { 
    // Remove last question answer data from storage
    let data = localStorage.getItem("data");
    if(data) 
    {
      data = JSON.parse(data);
      data.splice((data.length)-1, 1);
      localStorage.setItem("data", JSON.stringify(data));
    }

    //Set NarrativeUpdate state from props
    this.props.setIsNarrativeUpdate(true);
    this.props.handleNextPrevSteps(this.state.prevStep);
  }

  handleClose = () => {
    this.setState({ show: false });
  }

  handleShow = () => {
    this.setState({ show: true });
  }

  getAge(dateString) {
    var now = new Date();
    var today = new Date(now.getYear(),now.getMonth(),now.getDate());
  
    var yearNow = now.getYear();
    var monthNow = now.getMonth();
    var dateNow = now.getDate();
  
    var dob = new Date(dateString.substring(6,10),
                       dateString.substring(0,2)-1,                   
                       dateString.substring(3,5)                  
                       );
  
    var yearDob = dob.getYear();
    var monthDob = dob.getMonth();
    var dateDob = dob.getDate();
    var age = {};
    var ageString = "";
    var yearString = "";
    var monthString = "";
    var dayString = "";
  
  
    var yearAge = yearNow - yearDob;
  
    if (monthNow >= monthDob)
      var monthAge = monthNow - monthDob;
    else {
      yearAge--;
      var monthAge = 12 + monthNow -monthDob;
    }
  
    if (dateNow >= dateDob)
      var dateAge = dateNow - dateDob;
    else {
      monthAge--;
      var dateAge = 31 + dateNow - dateDob;
  
      if (monthAge < 0) {
        monthAge = 11;
        yearAge--;
      }
    }
  
    age = {
        years: yearAge,
        months: monthAge,
        days: dateAge
        };
  
    if ( age.years > 1 ) yearString = "years";
    else yearString = "year";
    if ( age.months> 1 ) monthString = "months";
    else monthString = "month";
    if ( age.days > 1 ) dayString = "days";
    else dayString = "day";
  
  
    if ( (age.years > 0) && (age.months > 0) && (age.days > 0) )
      ageString = age.years +"-"+ yearString+ "-old";
    else if ( (age.years == 0) && (age.months == 0) && (age.days > 0) )
      ageString = age.days +"-"+ dayString + "-old";
    else if ( (age.years > 0) && (age.months == 0) && (age.days == 0) )
      ageString = age.years +"-"+ yearString + "-old";
    else if ( (age.years > 0) && (age.months > 0) && (age.days == 0) )
      ageString = age.years +"-"+ yearString +"-old";
    else if ( (age.years == 0) && (age.months > 0) && (age.days > 0) )
      ageString = age.months +"-"+ monthString + " and " + age.days +"-"+ dayString + "-old";
    else if ( (age.years > 0) && (age.months == 0) && (age.days > 0) )
      ageString = age.years + yearString +"-old";
    else if ( (age.years == 0) && (age.months > 0) && (age.days == 0) )
      ageString = age.months +"-"+ monthString + "-old";
    else ageString = "";
  
    return ageString;
  }
  
  render() {
    return (
      <React.Fragment>
        <Header
          title="Patient Symptoms Narrative"
          titleImage="ic-medical-result.png"
        />
        <Menu />
        
        <section className="patient-symptom">
          <div className="container">
            <div className="patient-txt">
              <div className="row">
                <div className="col-md-3">
                  <div className="narrative-img">
                    <img
                      src={require("../assets/img/icons/female-doctor.png")}
                      alt=""
                    />
                    <h2 className="img-title">{CONFIG.Original_Narrative}</h2>
                  </div>
                </div>
                <div className="col-md-9">
                  <div className="txt-content">
                    {ReactHtmlParser(this.state.narrativeSummary)}
                  </div>
                  <div className="sec-btn patient--btn">

                    <Modal show={this.state.show} onHide={this.handleClose}>
                      <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">Patient Narrative</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Container>
                          <div className="sec-btn patient--btn">
                            <Link to="#" className="btn-img" onClick={this.handleUpdateAction}>
                              <img
                                src={require("../assets/img/icons/ic-incomplete-native.png")}
                                alt=""
                              />
                              <span>Edit Complain</span>
                            </Link>

                            <Link to="#" className="btn-img" onClick={this.addAnotherNarrative}>
                              <img
                                src={require("../assets/img/icons/ic-complete-native.png")}
                                alt=""
                              />
                              <span>Add Secondary Complain</span>
                            </Link>
                          </div>
                        </Container>
                      </Modal.Body>
                    </Modal>

                    <Link to={URLS.master} onClick={this.handleShow} className="btn-img">
                      <img
                        src={require("../assets/img/icons/ic-incomplete-native.png")}
                        alt=""
                      />
                      <span>{CONFIG.Incomplete_Narrative}</span>
                    </Link>

                    <Link to="#" className="btn-img" onClick={this.handleAction}>
                      <img
                        src={require("../assets/img/icons/ic-complete-native.png")}
                        alt=""
                      />
                      <span>{CONFIG.Accept_Narrative}</span>
                    </Link>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="row">
          <div className="col-md-3" />
          <div className="col-md-9">
            
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default PatientNarrative;
